

export const data = [
    {
        "id" : "1",
        "name" : "Arun",
        "batch" : "B42WD",
        "gender" : "Male",
        "experience": "2"
    }, 
    {
        "id" : "2",
        "name" : "Jayavel",
        "batch" : "B42WD",
        "gender" : "Male",
        "experience": "1"
    }, 
    {
        "id" : "3",
        "name" : "Santhosh",
        "batch" : "B42WD",
        "gender" : "Male",
        "experience": "3"
    }, 
    {
        "id" : "4",
        "name" : "Sharmila",
        "batch" : "B42WD",
        "gender" : "Female",
        "experience": "2"
    },
    {
        "id" : "5",
        "name" : "Keerthana",
        "batch" : "B42WD",
        "gender" : "Female",
        "experience": "3"
    },
    {
        "id" : "6",
        "name" : "Mathiyazhagan",
        "batch" : "B42WD",
        "gender" : "male",
        "experience": "1"
    }

]
export default data